import script from "./arrow-right-from-bracket.vue?vue&type=script&setup=true&lang=js"
export * from "./arrow-right-from-bracket.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__